module.exports = __webpack_public_path__ + "static/media/trafficAnalysisTotalBookings.c0e4c92a.svg";